import { render, staticRenderFns } from "./UserLeftCol.vue?vue&type=template&id=3beac1d5&"
import script from "./UserLeftCol.vue?vue&type=script&lang=js&"
export * from "./UserLeftCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports